// API configuration for the frontend
// In production: use absolute URL to api.crystalwashkw.com
// In development: use relative /api which gets proxied by Vite or Express

export const API_URL = import.meta.env.PROD
  ? 'https://api.crystalwashkw.com/api'
  : '/api';

// Helper function to build full API URLs
export const buildApiUrl = (path: string) => {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_URL}${cleanPath}`;
};
